<template>
  <template v-if="editableMode">
    <tr class="font-bold">
      <td class="align-middle px-2 text-center border-r border-t-8" rowspan="2" />
      <th class="px-6 py-2 w-4/12 text-left border-r border-t-8">
        Item
      </th>
      <th class="px-6 py-2 w-3/12 text-left border-r border-t-8">
        Unit
      </th>
      <th class="px-6 py-2 w-3/12 text-right border-r border-t-8">
        Quantity
      </th>
      <td
        v-if="!disabled"
        class="py-2 border-l border-t-8"
        rowspan="2">
        <div class="flex items-center px-6 py-4">
          <button title="Save Changes" @click="store">
            <Icon icon="ic:baseline-save" class="block w-6 h-6 fill-gray-400" />
          </button>
          <button title="Cancel Edit" @click="cancel">
            <Icon icon="ic:baseline-restart-alt" class="block w-6 h-6 fill-gray-400" />
          </button>
        </div>
      </td>
    </tr>
    <tr>
      <td class="border-r border-t">
        <vSelect
          v-model="detail.item"
          class="focus:text-indigo-500"
          :class="{ error: errors.item_id }"
          placeholder="[Pick Item...]"
          label="name"
          :filterable="false"
          :options="options"
          :append-to-body="true"
          @search="onSearch" />
        <div v-if="errors.item_id" class="form-error whitespace-normal">
          {{ errors.item_id }}
        </div>
      </td>
      <td class="border-r border-t">
        <vSelect
          v-model="detail.unit"
          label="name"
          placeholder="[Pick Unit...]"
          :class="{ error: errors.unit_id }"
          :options="unitOptions"
          :append-to-body="true" />
        <div v-if="errors.item_unit_id" class="form-error -py-4 px-3 whitespace-normal">
          {{ errors.unit_id }}
        </div>
      </td>
      <td class="text-right border-r border-t">
        <div class="text-right">
          <number-input
            v-model="detail.qty"
            class=""
            :error="errors.qty" />
        </div>
      </td>
    </tr>
  </template>
  <template v-else>
    <tr class="font-bold">
      <td class="align-middle px-2 text-center border-r border-t-8" rowspan="2">
        {{ rowIndex }}.
      </td>
      <th class="px-6 py-2 w-4/12 text-left border-r border-t-8">
        Item
      </th>
      <th class="px-6 py-2 w-3/12 text-left border-r border-t-8">
        Unit
      </th>
      <th class="px-6 py-2 w-3/12 text-right border-r border-t-8">
        Quantity
      </th>
      <td
        v-if="!disabled"
        class="py-2 border-l border-t-8"
        rowspan="2">
        <div class="flex items-center px-6 py-4">
          <button title="Edit Detail" @click="edit">
            <Icon icon="ic:baseline-edit-note" class="block w-6 h-6 fill-gray-400" />
          </button>
          <button title="Delete Detail" @click="destroy">
            <Icon icon="ic:baseline-delete" class="block w-6 h-6 fill-gray-400" />
          </button>
        </div>
      </td>
    </tr>
    <tr>
      <td class="border-r border-t">
        <div class="flex items-center px-6 focus:text-indigo-500">
          {{ packageDetail.item.name }}
        </div>
      </td>
      <td class="border-r border-t">
        <div class="flex items-center px-6 py-4">
          {{ packageDetail.unit.name }}
        </div>
      </td>
      <td class="text-right border-r border-t">
        <div class="px-6 py-4 text-right">
          {{ formatNumber(packageDetail.qty) }}
        </div>
      </td>
    </tr>
  </template>
</template>

<script lang="js">
import { Icon } from '@iconify/vue'
import { ref } from 'vue'
import vSelect from 'vue-select'
import NumberInput from '@/Shared/NumberInput'
import 'vue-select/dist/vue-select.css'
import throttle from 'lodash/throttle'
import clone from 'lodash/clone'

export default {
    components: {
        Icon,
        vSelect,
        NumberInput,
    },
    props: {
        packageDetail: Object,
        errors: Object,
        units: Array,
        editableMode: {
            type: Boolean,
            default: false,
        },
        rowIndex: {
            type: Number,
            default: 1,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['destroy:detail', 'cancel', 'save', 'edit:detail'],
    setup (props) {
        const options = ref(props.packageDetail.item ? [{ id: props.packageDetail.item.id, name: props.packageDetail.item.name }] : [])
        const detail = ref(props.packageDetail)
        const oriData = ref(typeof packageDetail)
        const search = throttle((loading, search) => {
            fetch(`/items?options=1&search=${escape(search)}`).then((res) => {
                res.json().then((json) => (options.value = json.items))
                loading(false)
            })
        }, 500)
        const unitOptions = ref(props.packageDetail.unit ? [props.packageDetail.unit] : [])

        return {
            search,
            options,
            detail,
            oriData,
            unitOptions,
        }
    },
    watch: {
        'detail.item' (newVal) {
            if (newVal) {
                this.detail.unit = null
                this.unitOptions = this.units.filter(i => newVal.units.includes(i.id))
            }
        },
    },
    methods: {
        formatNumber (num) {
            return num ? num.toLocaleString('id-ID') : '0'
        },
        onSearch (search, loading) {
            if (search.length) {
                loading(true)
                this.search(loading, search)
            }
        },
        edit () {
            this.oriData = clone(this.packageDetail)
            this.$emit('edit:detail', this.detail)
        },
        cancel () {
            this.detail = clone(this.oriData)
            this.$emit('cancel')
        },
        store () {
            this.$emit('save', this.detail)
        },
        destroy () {
            if (confirm('Are you sure you want to delete this details?')) {
                this.$emit('destroy:detail', this.packageDetail.id)
            }
        },
    },
}
</script>

<style scoped>
.v-select {
  --vs-line-height: 1.9;
}
</style>
